<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>动态属性创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/dynamic')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <tz-form
        width="110px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
      ></tz-form>
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addDynamic } from '@/api/dynamic'
import { queryEquipment } from '@/api/dictionary'

export default {
  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '设备类型',
          field: 'deviceType',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '设备类型必填', trigger: 'blur' }]
        },
        {
          label: '模板类型',
          field: 'templateType',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '模板类型必填', trigger: 'blur' }]
        },
        {
          label: '属性名',
          field: 'attributeName',
          type: 'text',
          rules: [{ required: true, message: '属性名必填', trigger: 'blur' }]
        },
        {
          label: '属性标签',
          field: 'attributeLabel',
          type: 'text',
          rules: [{ required: true, message: '属性标签必填', trigger: 'blur' }]
        },
        {
          label: '是否必填',
          field: 'type',
          type: 'radio',
          radiolist: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '是'
            }
          ]
        }
      ],
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        }
        // {
        //   content: '重置',
        //   width: '185px',
        //   type: ''
        // }
      ]
    }
  },
  created() {
    this.queryEquipmentFn()
  },
  methods: {
    //获取设备类型
    queryEquipmentFn() {
      let types = ['equipment_type', 'template_type']
      queryEquipment(types).then((res) => {
        console.log(res.data, '设备类型')
        this.formConfig[0].payload = res.data.equipment_type
        this.formConfig[1].payload = res.data.template_type
        // this.deviceTypeList = res.data.equipment_type
        // this.templateList = res.data.template_type
        // this.dialogDeviceTypeList = res.data
      })
    },
    submitFn(formData) {
      console.log(formData, '属性创建')
      if (this.submited) return
      this.$loading({
        text: '属性添加中'
      })
      let infos = JSON.parse(JSON.stringify(formData))
      let addparams = {
        attributeLabel: infos.attributeLabel,
        deviceType: infos.deviceType,
        templateType: infos.templateType,
        attributeName: infos.attributeName,
        status: 1, //1启用2禁用，默认启用
        type: infos.type ? infos.type : 0
      }
      console.log(addparams, '属性创建')

      addDynamic(addparams).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.submited = true
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
      })
      this.$loading().close()
    }
  }
}
</script>

<style></style>
